/* eslint-disable react-native/no-inline-styles */
/* eslint-disable-next-line react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Input from './Input';
import Image from '@components/global/Image';
import SociollaDatePicker from '@components/sociolla/SociollaDatePicker';
import { parseDate } from '@global/helpers';
import { INPUT_HEIGHT } from '@/constants';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  moreLeft: PropTypes.bool,
  iconStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
};

const defaultProps = {
  testID: 'date-picker',
  label: '',
  hideLabel: false,
  value: '',
  moreLeft: false,
  iconStyle: {},
  style: {},
};

const DatePickerDefault = (props) => {
  const {
    testID = 'date-picker',
    label = '',
    hideLabel = false,
    value = '',
    moreLeft = false,
    iconStyle = {},
    style = {},
  } = props;

  const [showDatePicker, setShowDatePicker] = useState(false);

  // show or hide date picker popup
  const handleConfirm = (value) => {
    try {
      // eslint-disable-next-line react/prop-types
      props.onChange(value);
      setShowDatePicker(false);
    } catch (error) {
      setShowDatePicker(false);
    }
  };

  const openDatePicker = () => {
    setShowDatePicker(true);
  };

  return (
    <View testID={testID} style={[{ position: 'relative' }, style || {}]}>
      {/* Overlay Click */}
      <TouchableOpacity
        testID={`${testID}-overlay`}
        style={[
          styles.inputDate,
          { height: INPUT_HEIGHT, top: !label || hideLabel ? 0 : 30 },
        ]}
        disabled={props.disabled}
        activeOpacity={1}
        onPress={() => openDatePicker()}
      />
      {/* Form Input Container */}
      <Input
        {...props}
        inputContainerStyle={{ height: INPUT_HEIGHT }}
        editable={false}
        value={`${value ? parseDate(value, 'd MMM yyyy') : ''}`}
        rightIcon={
          <View
            style={{
              marginRight: moreLeft ? 0 : -10,
              ...(moreLeft ? { marginLeft: -26 } : {}),
              ...iconStyle,
            }}>
            <Image
              style={{ width: 23, height: 16 }}
              width={23}
              height={16}
              svg={true}
              source={require('@assets/img/icons/menu/calendar.svg')}
            />
          </View>
        }
      />
      {/* Date Picker Popup */}
      <SociollaDatePicker
        {...props}
        visible={showDatePicker}
        value={value ? new Date(value) : new Date()}
        style={{ width: '100%' }}
        onClose={() => setShowDatePicker(false)}
        onChange={handleConfirm}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  // eslint-disable-next-line react-native/no-color-literals
  inputDate: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 2,
    elevation: 2,
  },
});

DatePickerDefault.propTypes = propTypes;
DatePickerDefault.defaultProps = defaultProps;

export default React.memo(DatePickerDefault, (prev, next) => prev == next);
